var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { map } from 'rxjs/operators';
var ReportCardsService = /** @class */ (function () {
    function ReportCardsService(http, authService) {
        var _this = this;
        this.http = http;
        this.authService = authService;
        this.baseUrl = environment.API_URL;
        this.getReportCardsForStudent = function (studentId) {
            return _this.http.get(_this.baseUrl + '/api/v1/report-cards', {
                params: {
                    tenantId: _this.authService.getTenant()._id,
                    termId: _this.authService.getSelectedTerm()._id,
                    stageId: _this.authService.getSelectedStage()._id,
                    studentId: studentId
                }
            }).pipe(map(function (reportCards) {
                return reportCards.map(function (e) {
                    e.title = 'Boletín ' + e.termDescription;
                    return e;
                });
            }));
        };
        this.getReportCardsForStudents = function (studentIds, divisionId) { return __awaiter(_this, void 0, void 0, function () {
            var reportCards, _i, studentIds_1, studentId, reportCard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reportCards = [];
                        _i = 0, studentIds_1 = studentIds;
                        _a.label = 1;
                    case 1:
                        if (!(_i < studentIds_1.length)) return [3 /*break*/, 4];
                        studentId = studentIds_1[_i];
                        return [4 /*yield*/, promisify(this.getReportCardsForStudent(studentId))];
                    case 2:
                        reportCard = (_a.sent())
                            .filter(function (e) { return e.divisionId === divisionId; })[0];
                        if (reportCard) {
                            reportCards.push(reportCard);
                        }
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, reportCards];
                }
            });
        }); };
        this.getSubjectReportCardsForDivisionAndCourse = function (divisionId, courseId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, promisify(this.http.get(this.baseUrl + "/api/v1/report-cards/divisions/" + divisionId + "/courses/" + courseId))];
            });
        }); };
    }
    ReportCardsService.prototype.getReportCardById = function (reportCardId) {
        return this.http.get(this.baseUrl + '/api/v1/report-cards/' + reportCardId);
    };
    ReportCardsService.prototype.applyActions = function (reportCardId, actions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.patch(this.baseUrl + '/api/v1/report-cards/' + reportCardId, actions).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ReportCardsService;
}());
export { ReportCardsService };
function promisify(observable) {
    return new Promise(function (resolve, reject) {
        observable.subscribe(resolve, reject);
    });
}
